/**
 * Click an email link -> copy the address to the clipboard instead of
 * opening a mail app. Marked up as [data-copy-email] on a mailto: anchor,
 * so if this script never loads the link still works the normal way.
 */
(function () {
  function feedback(el, msg) {
    // Button uses an inner .btn__label; inline links swap their own text.
    var target = el.querySelector('.btn__label') || el;
    if (el.dataset.copyBusy === '1') return;
    el.dataset.copyBusy = '1';

    var original = target.textContent;
    var arrow = el.querySelector('.btn__arrow');
    var originalArrow = arrow ? arrow.textContent : null;

    target.textContent = msg;
    if (arrow) arrow.textContent = '✓';
    el.classList.add('is-copied');

    setTimeout(function () {
      target.textContent = original;
      if (arrow) arrow.textContent = originalArrow;
      el.classList.remove('is-copied');
      el.dataset.copyBusy = '0';
    }, 1600);
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-copy-email]');
    if (!el) return;

    var addr = (el.getAttribute('href') || '').replace(/^mailto:/i, '').split('?')[0];
    if (!addr) return;

    e.preventDefault();

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(addr).then(
        function () { feedback(el, 'Copied!'); },
        function () {
          // Clipboard API can reject on permissions; fall back before giving up.
          feedback(el, legacyCopy(addr) ? 'Copied!' : 'Copy failed');
        }
      );
    } else {
      feedback(el, legacyCopy(addr) ? 'Copied!' : 'Copy failed');
    }
  });
})();
